import CurrencySetup from './currency_setup';

export const replaceValueMarkerWithValue = value => x => x.replace(
    CurrencySetup.valueMarker,
    value
);
